(() => {
  const matches = (query) => typeof window !== 'undefined' && window.matchMedia && window.matchMedia(query).matches;

  const isFinePointer = () => matches('(hover: hover) and (pointer: fine)');
  const isMobileWidth = () => matches('(max-width: 749px)');

  const setup = (gallery) => {
    const slider = gallery.querySelector('ul[id^="Slider-Gallery"]');
    if (!slider) return;
    if (slider.dataset.wheelScrollPassthrough === 'true') return;
    slider.dataset.wheelScrollPassthrough = 'true';

    slider.addEventListener(
      'wheel',
      (event) => {
        if (!isFinePointer() || !isMobileWidth()) return;
        if (event.defaultPrevented) return;
        if (event.ctrlKey) return; // pinch-zoom
        if (event.shiftKey) return; // allow horizontal wheel behavior

        const deltaX = Math.abs(event.deltaX || 0);
        const deltaY = Math.abs(event.deltaY || 0);
        if (deltaX > deltaY) return;

        const canScrollHorizontally = slider.scrollWidth - slider.clientWidth > 1;
        if (!canScrollHorizontally) return;

        event.preventDefault();
        window.scrollBy({ top: event.deltaY, left: 0, behavior: 'auto' });
      },
      { passive: false }
    );
  };

  const init = () => document.querySelectorAll('media-gallery').forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('product-info:loaded', init);
})();

